<shared-nav-bar></shared-nav-bar>

<shared-hero-background></shared-hero-background>
<shared-filters-draw></shared-filters-draw>
<shared-main-draw [pre]="preContent" [post]="postContent">
    <ng-content></ng-content>
</shared-main-draw>
<shared-sub-draw></shared-sub-draw>
<shared-footer></shared-footer>
